module.exports = __webpack_public_path__ + "static/media/imagen_caletascovid-19.93e77851.jpg";